// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"7401":"baeaa4ff","9386":"7d384bb9"}[chunkId] || chunkId) + "." + {"2854":"95c2e3403068273b","3419":"75b886ad3d7973d5","7401":"efd3f33ebdc825e4","8398":"e789519feb65db4d","9386":"d53ad0f7977da576"}[chunkId] + ".js";
};